angular.module('imagetrend.components')
    .directive('hlpAddressLookup', [
        '$templateCache', 'Countries', 'Regions', '$parse',
        function ($templateCache, Countries, Regions, $parse) {
            return {
                scope: {
                    ngModel: '=?',
                    parameters: '=?',
                    street1: '@?',
                    street2: '@?',
                    city: '@?',
                    county: '@?',
                    state: '@?',
                    postal: '@?',
                    country: '@?',
                    name: '@?',
                    number: '@?',
                    gpsLatitude: '@?',
                    gpsLongitude: '@?'
                },
                template: function () {
                    return $templateCache.get('templates/address-lookup/address-lookup.html');
                },
                link: function (scope, elem, attrs) {
                    // Prepare setter functions for each property in form builder
                    var parentScope = scope.$parent;
                    var setters = {};
                    ['street1', 'street2', 'city', 'county', 'state', 'postal', 'country', 'name', 'number', 'gpsLatitude', 'gpsLongitude'].forEach(function (prop) {
                        if (attrs[prop]) {
                            setters[prop] = $parse(attrs[prop]).assign;
                        }
                    });

                    scope.$watch('ngModel', function (newVal) {
                        if (newVal) {
                            if (setters.name) setters.name(parentScope, newVal.name || '');
                            if (setters.number) setters.number(parentScope, newVal.number || '');
                            if (setters.gpsLatitude) setters.gpsLatitude(parentScope, newVal.gpsLatitude || '');
                            if (setters.gpsLongitude) setters.gpsLongitude(parentScope, newVal.gpsLongitude || '');
                            if (setters.street1) setters.street1(parentScope, newVal.address1 || '');
                            if (setters.street2) setters.street2(parentScope, newVal.address2 || '');
                            if (setters.city) setters.city(parentScope, newVal.city || '');
                            if (setters.county) setters.county(parentScope, newVal.county || '');
                            if (setters.postal) setters.postal(parentScope, newVal.postalCode || '');
                            if (setters.country && newVal.country) {
                                Countries.getByAbbrev(newVal.country).then(function (data) {
                                    setters.country(parentScope, data.id);
                                });
                            }
                            if (setters.state && newVal.state) {
                                Regions.getByAbbrev(newVal.state).then(function (data) {
                                    setters.state(parentScope, data.id);
                                });
                            }
                        }
                    });
                }
            };
        }
    ]);